import * as CardValidator from 'card-validator';

export const ccNumberFormatter = getHandler((value) => {
    const result = CardValidator.number(value);
    const maxLength =
        result.card && result.card.lengths ? Math.max.apply(null, result.card.lengths) : 19;
    const gaps = result.card && result.card.gaps ? result.card.gaps : [4, 8, 12];
    const digitsValue = value.replace(/[^\d]/g, '').substr(0, maxLength);
    let newValue = '';
    let lastGap = 0;
    for (let i = 0; i <= gaps.length; i += 1) {
        const gap = gaps[i] || digitsValue.length;
        newValue += digitsValue.substring(lastGap, gap);
        if (gap < digitsValue.length) {
            newValue += ' ';
        }
        lastGap = gap;
    }
    return newValue;
});

export const ccExpFormatter = getHandler((value) => {
    if (/\d\d\//.test(value)) {
        // Skip if current input is `MM/` to preserve slash
        return null;
    }

    const digitsValue = value.replace(/[^\d]/g, '');
    if (digitsValue.length <= 2) {
        return digitsValue;
    }
    return `${digitsValue.substring(0, 2)}/${digitsValue.substring(2, 4)}`;
});

type TransformFunc = (value: string) => string | null;

function getHandler(func: TransformFunc) {
    return (element?: HTMLInputElement) => {
        if (element) {
            element.addEventListener('keyup', (event) => handleEvent(event, true, func));
            element.addEventListener('blur', (event) => handleEvent(event, true, func));
        }
    };
}

function handleEvent(event: Event, isKeyUp: boolean, formatter: TransformFunc) {
    const elem = event.currentTarget as HTMLInputElement;
    const value = elem.value;

    if (
        isKeyUp &&
        (elem.selectionStart !== elem.selectionEnd || elem.selectionEnd !== elem.value.length)
    ) {
        // Skip if cursor is not at end of text
        return;
    }

    const newValue = formatter(value);

    if (newValue != null && newValue !== value) {
        elem.value = newValue;
        elem.setSelectionRange(newValue.length, newValue.length);
    }
}
